/*
 * @Author: 刘小博
 * @Date: 2023-02-17 10:39:32
 * @LastEditTime: 2023-04-14 16:48:27
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\mg\file-info-manage\modules\otherRouter.js
 * 其他
 */
const otherRouter = [
  // 芒哥 关联关系维护
  {
    path: '/mg/incidence-maintain',
    name: 'MgIncidenceMaintain',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/incidenceMaintain.vue' // 待删除
        '@/views/mg/file-info-manage/other/incidence-relation/Page.vue'
      ),
    meta: {
      SecondaryMenu: '其他', //二级菜单
      title: '关联关系维护',
    },
  },
  // 芒哥 关联关系维护 详情
  {
    path: '/mg/incidence-maintain-detail/:id',
    name: 'MgIncidenceMaintainDetail',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/incidenceMaintainDetail.vue'// 待删除
        '@/views/mg/file-info-manage/other/incidence-relation/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '其他', //二级菜单
      title: '服务商关联关系详情',
      breadcrumb: [
        {
          title: '关联关系维护',
          name: 'MgIncidenceMaintain',
        },
      ],
    },
  },

  // 芒哥 关联关系维护 历史关联关系
  {
    path: '/mg/historical-relevance',
    name: 'MgHistoricalRelevance',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/HistoricalRelevance.vue' // 待删除 History
        '@/views/mg/file-info-manage/other/incidence-relation/History.vue'
      ),
    meta: {
      SecondaryMenu: '其他', //二级菜单
      title: '历史关联关系',
      breadcrumb: [
        {
          title: '关联关系维护',
          name: 'MgIncidenceMaintain',
        },
      ],
    },
  },
  // 芒哥 关联关系维护 导入关联关系 1导入 2解除
  {
    path: '/mg/incidence-maintain-import/:meta_type',
    name: 'MgIncidenceMaintainImport',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/incidenceMaintainImport.vue' // 待删除
        '@/views/mg/file-info-manage/other/incidence-relation/Import.vue'
      ),
    meta: {
      SecondaryMenu: '其他', //二级菜单
      isMoreMeta: true,
      1: {
        title: '导入综合服务商关联关系',
        breadcrumb: [
          {
            title: '关联关系维护',
            name: 'MgIncidenceMaintain',
          },
        ],
      },
      2: {
        title: '解除综合服务商关联关系',
        breadcrumb: [
          {
            title: '关联关系维护',
            name: 'MgIncidenceMaintain',
          },
        ],
      },
    },
  },

  // 芒哥 账号使用情况
  {
    path: '/mg/account-condition',
    name: 'MgAccountCondition',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/AccountCondition.vue' // 待删除
        '@/views/mg/file-info-manage/other/account-condition/Page.vue'
      ),
    meta: {
      SecondaryMenu: '其它', //二级菜单
      title: '账号使用统计',
    },
  },
  // 芒哥 综合服务商详情
  {
    path: '/mg/cooperation-manage/service-detail/:id/:client_id/:meta_type',
    name: 'MgManageServiceDetail',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/cooperation-manage/detail.vue'  // 待删除
        '@/views/mg/file-info-manage/other/account-condition/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '账号信息管理', //二级菜单
      isMoreMeta: true,
      2: {
        title: '综合服务商账号详情',
        breadcrumb: [
          {
            title: '综合服务商账号',
            name: 'MgManageServiceList',
          },
        ],
      },
      3: {
        title: '综合服务商账号详情',
        breadcrumb: [
          {
            title: '账号使用统计',
            name: 'MgAccountCondition',
          },
        ],
      },
    },
  },
]
export default otherRouter
